module.exports={
	"Scope": "Role-List",
	"CoreEntity": "Role",
	"TitleTemplate": "Roles",
	"Descriptors":
	{
		"Name":
		{
			"Name": "Name",
			"Hash": "RoleListName",
			"PictDashboard": {}
		},
		"PermissionLevel":
		{
			"Name": "Permission Level",
			"Hash": "RoleListPermissionLevel",
			"PictDashboard": {}
		},
		"Type":
		{
			"Name": "Type",
			"Hash": "RoleListType",
			"PictDashboard": {}
		}
	}
}
